import React from "react";

export function BrandSymbol({ size = 32 }: { size?: number }) {
  return (
    <img data-testid="brand-symbol" src="/brand-symbol.webp" alt="" aria-hidden
      className="inline-block shrink-0 object-contain" style={{ width: size, height: size }} />
  );
}

export function Wordmark({ size = 29 }: { size?: number }) {
  return (
    <span data-testid="brand-wordmark" role="img" aria-label="Nexstays" className="inline-flex items-center gap-2">
      <BrandSymbol size={size} />
      <img src="/brand-text.webp" alt="" aria-hidden className="block w-auto" style={{ height: Math.round(size * 0.42) }} />
    </span>
  );
}

export function BrandLogo({ height = 120 }: { height?: number }) {
  return <img data-testid="brand-logo" src="/brand-logo.webp" alt="Nexstays" className="block w-auto" style={{ height }} />;
}
